import { render, staticRenderFns } from "./SettingsNotificationSmsFrom.vue?vue&type=template&id=50c78634&"
import script from "./SettingsNotificationSmsFrom.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmsFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports